export enum DocumentTypeScan{
  PASSPORT = 'passport',
  BOARDING_PASS = 'boardingPass'
}

export enum ResultModalSelect{
  CLOSED = 1,
  ACCEPT =2
}


export enum TypeLoading {
  FOOTER_LOADING,
  COMPONENT_LOADING,
  FULL_LOADING
}

export type TypeLoadingGif  = 'FOOTER_LOADING' | 'COMPONENT_LOADING' | 'FULL_LOADING'